module.exports = __webpack_public_path__ + "img/12_18.8d49099a.png";